import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSliderChange } from '@angular/material/slider';
import { DisplaySettings } from '../display-settings';
import * as settings from '../../common/settings';
import * as aspSettings from '../../asp/aspSettings';
import { constsMngr } from '../../common/consts';
import { ColorPickerComponent } from '../../common/color-picker/color-picker.component';
import { ColorPickerService } from '../../common/color-picker/color-picker.service';
import { MapMngr } from '../../asp/MapMngr';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { Animations } from '@core_n/Animations';

@Component({
  selector: 'tracks-settings',
  templateUrl: './nainat-settings.component.html',
  styleUrls: ['../display-filter.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})

export class NaiNatSettingsComponent extends ZIndexMngr implements AfterViewInit {
  @ViewChild('ColorButtonNai', { read: ElementRef }) private ColorButtonNai: ElementRef;
  @ViewChild('ColorButtonNat', { read: ElementRef }) private ColorButtonNat: ElementRef;

  private currentNaiColor: string;
  private currentNatColor: string;
  private defaultStyleColor: string;

  public naiFillOpacity: number;
  public natFillOpacity: number;

  static readonly DIALOG_ID = "Nai Nat Settings";
  exIpFillBrightness: number = settings.userSettings.IpFillOpacity * 100.0;
  nai: boolean = true;
  nat: boolean = true;

  constructor(public dialogRef: MatDialogRef<NaiNatSettingsComponent>,
    private colorPickerSvc: ColorPickerService,
    elementRef: ElementRef) {
    super(elementRef);
    let style = getComputedStyle(document.body);
    this.defaultStyleColor = style.getPropertyValue('--default-color');
    this.currentNaiColor = settings.userSettings.naiColor;
    this.currentNatColor = settings.userSettings.natColor;
    this.nai =  settings.userSettings.naiActive;
    this.nat =  settings.userSettings.natActive;
    this.naiFillOpacity = settings.userSettings.naiFillOpacity * 100;
    this.natFillOpacity = settings.userSettings.natFillOpacity * 100;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  naiBoxClick(e: any) {
    this.nai = !this.nai;
    settings.userSettings.setNaiActive(this.nai);
  }

  natBoxClick(e: any) {
    this.nat = !this.nat;
    settings.userSettings.setNatActive(this.nat);
  }

  // color button ip
  isColorPickerActive() {
    return this.colorPickerSvc.isColorPickerShown();
  }

  async onNaiColorClick() {
    let color = await this.colorPickerSvc.showColorPicker(this.ColorButtonNai, this.currentNaiColor);
    if (color) {
      this.currentNaiColor = color;
      settings.userSettings.setNaiColor(color);
    }
  }

  colorPickerIconNai() {
    return `linear-gradient(${this.currentNaiColor}, ${this.defaultStyleColor})`;
  }

  async onNatColorClick() {
    let color = await this.colorPickerSvc.showColorPicker(this.ColorButtonNat, this.currentNatColor);
    if (color) {
      this.currentNatColor = color;
      settings.userSettings.setNatColor(color);
    }
  }

  colorPickerIconNat() {
    return `linear-gradient(${this.currentNatColor}, ${this.defaultStyleColor})`;
  }

  naiBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setNaiFillOpacity(event.value / 100.0);
  }

  natBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setNatFillOpacity(event.value / 100.0);
  }

  // Slider Stuff

  minBrightness() {
    return 0;
  }

  maxBrightness() {
    return 100;
  }
}
